import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import SvgIcon from "../../../../parts/SvgIcon";
import useClickOutside from "../../../../hooks/useClickOutside";

const UnSelectedMembers = ({
  selectedAthletesForMobile = [], //this is only for the mobile component to select and unselect in the same screen
  classNames = "",
  athletes,
  toggleAthlete,
  referAsClients,
  theme,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [isEditing, setIsEditing] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredAthletes, setFilteredAthletes] = useState(athletes);
  const inputRef = useRef(null);
  const ulRef = useRef(null);
  const handleClickOutsideInput = () => {
    setSearch("");
    setIsEditing(false);
  };
  useClickOutside(inputRef, handleClickOutsideInput, [ulRef.current]);
  useEffect(() => {
    if (search.length > 0)
      setFilteredAthletes(
        athletes.filter((athlete) =>
          athlete.name.toLowerCase().includes(search.toLowerCase())
        )
      );
    else setFilteredAthletes(athletes);
  }, [search, athletes]);

  /**
   * Function to call the toggleAthlete for the mobile component
   */
  const handleToggleAthleteForMobile = (selected, _id) => {
    if (!selected) {
      //we have to add
      toggleAthlete(
        athletes.findIndex((item) => item._id === _id),
        false
      );
    } else {
      //we have to remove
      toggleAthlete(
        selectedAthletesForMobile.findIndex((item) => item._id === _id),
        true
      );
    }
  };

  return (
    <div className={`members-list ${classNames}`}>
      <header>
        {isEditing ? (
          <>
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t("athletes.unselectedMembers.searchPlaceholder")}
              ref={inputRef}
            />
            <SvgIcon
              role="button"
              data-button-type="text-white"
              data-icon-only="true"
              data-icon
              sz="small"
              onClickFn={() => {
                setSearch("");
              }}
              src="/img/new-icons/close-search.svg"
            />
          </>
        ) : (
          <>
            <p className="s1" onClick={() => setIsEditing(true)}>
              {referAsClients
                ? t("athletes.unselectedMembers.clientsList")
                : t("athletes.unselectedMembers.athletesList")}
            </p>
          </>
        )}
      </header>
      <ul ref={ulRef}>
        {filteredAthletes.map((elem, index) => (
          <li
            key={elem._id || index}
            onClick={() =>
              !elem.selected &&
              toggleAthlete(
                athletes.findIndex((item) => item._id === elem._id),
                false
              )
            }
          >
            <img
              src={
                elem.selected
                  ? "/img/new-icons/tick-circle.svg"
                  : getAvatarUrl(elem, false, theme, true)
              }
            />
            <span>{elem.name}</span>
            {/* for desktop */}
            {!elem.selected && (
              <SvgIcon
                role="button"
                data-button-type="text-white"
                data-icon-only="true"
                classNames="force-mobile-hidden"
                src="/img/new-icons/add.svg"
              />
            )}
            {/* for mobile */}
            <img
              className="mobile-img force-only-show-mobile"
              onClick={() =>
                handleToggleAthleteForMobile(elem.selected, elem._id)
              }
              src={
                elem.selected
                  ? "/img/new-icons/red-cross-20px.svg"
                  : "/img/new-icons/add.svg"
              }
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UnSelectedMembers;
